import { generatePageMetadata } from "@/lib/seo/metadata";
import { getStructuredData } from "@/lib/seo/structured-data";
import { ForClippingPlatformsHero } from "@/features/landing/components/ForClippingPlatformsHero";
import { PlatformPartners } from "@/features/landing/components/PlatformPartners";
import { Faq } from "@/shared/sections/Faq";
import { MarketingPage } from "@/shared/layout/MarketingPage";

const clippingMetadata = generatePageMetadata({
  title: "For Clipping Platforms",
  description:
    "Monetize your clipping community with Evangelist. Connect verified creators to enterprise brand demand, with brand safety checks and payments automated.",
  path: "/for-clipping-platforms",
});
const clippingStructuredData = getStructuredData("for-clipping-platforms");

const ClippingPlatformsPage = () => {
  return (
    <MarketingPage metadata={clippingMetadata} structuredData={clippingStructuredData}>
      <ForClippingPlatformsHero />
      <PlatformPartners baseAnalyticsElementId="platform-partners:discord" />
      <Faq className="w-full" />
    </MarketingPage>
  );
};

export default ClippingPlatformsPage;
